module.exports = __webpack_public_path__ + "static/media/127.3f6e6c25.png";